import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';

import PageHeader from '#common/PageHeader';

import ProjectTemplate from './ProjectTemplate';
import { ProjectPreview } from './ProjectTemplate.style';

const ProjectsWrapper = styled.section`
  ${props => props.theme.spacing.sectionBottom};
`;

const Projects = () => {
  const projects = useStaticQuery(
    graphql`
      query {
        allProjectsJson {
          edges {
            node {
              description
              title
              id
              links {
                image
              }
            }
          }
        }
      }
    `
  );

  return (
    <ProjectsWrapper id="projects" style={{ marginBottom: 100 }}>
      <PageHeader>Projects</PageHeader>
      <p style={{ marginBottom: 100, textAlign: 'center', fontSize: 18 }}>
        Here are a few projects I've worked on recently.
        <p style={{ marginBottom: 100, textAlign: 'center', fontSize: 18 }}>
          Want to see more?
          <a href="mailto:samartekaya51@gmail.com" target="__blank" rel="noreferrer noopener">
            &nbsp;Email me.
          </a>
        </p>
      </p>
      {projects.allProjectsJson.edges.map(({ node }) => (
        <ProjectTemplate
          key={node.id}
          title={node.title}
          desc={node.description}
          preview={
            <ProjectPreview>
              <img style={{ width: '80%' }} src={node.links.image} alt="" />
            </ProjectPreview>
          }
        />
      ))}
    </ProjectsWrapper>
  );
};

export default Projects;
